import { Card } from "@/components/ui/card";
import { MapPin, Phone, Mail, Clock, Facebook } from "lucide-react";
import { PublicHeader } from "@/components/Layout";

const FACEBOOK_URL = "https://www.facebook.com/share/195BsporBu/";

export default function Contact() {
  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-950">
      <PublicHeader />
      <main className="w-full max-w-5xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <div className="text-xs uppercase tracking-[0.2em] font-semibold text-blue-600 dark:text-blue-400 mb-3">Get in touch</div>
          <h1 className="font-display font-black text-4xl md:text-6xl tracking-tight text-slate-900 dark:text-white leading-[1.05]" data-testid="contact-title">
            Contact Us
          </h1>
          <p className="mt-4 text-slate-600 dark:text-slate-400">
            Reach out with any question about credential verification, partnership onboarding, or your account.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <ContactCard icon={MapPin} label="Address" testId="contact-address">
            <div className="text-slate-700 dark:text-slate-200 leading-relaxed">
              Bardnersville Junction<br />
              Japan Freeway, Montserrado County<br />
              Republic of Liberia
            </div>
          </ContactCard>

          <ContactCard icon={Phone} label="Hotline" testId="contact-hotline">
            <a
              href="tel:+231886954583"
              className="text-slate-900 dark:text-white font-mono text-lg font-semibold hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
              data-testid="contact-hotline-link"
            >
              +231-886-954-583
            </a>
          </ContactCard>

          <ContactCard icon={Mail} label="Email" testId="contact-email">
            <a
              href="mailto:admin@certiseal.net"
              className="text-slate-900 dark:text-white text-lg font-semibold hover:text-blue-600 dark:hover:text-blue-400 transition-colors break-all"
              data-testid="contact-email-link"
            >
              admin@certiseal.net
            </a>
          </ContactCard>

          <ContactCard icon={Clock} label="Working Hours" testId="contact-hours">
            <div className="text-slate-700 dark:text-slate-200 leading-relaxed">
              Mondays – Fridays<br />
              <span className="font-semibold text-slate-900 dark:text-white">9:00 AM – 5:00 PM</span>
            </div>
          </ContactCard>
        </div>

        {/* Facebook */}
        <div className="mt-10 flex items-center justify-center">
          <a
            href={FACEBOOK_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 px-6 py-3 rounded-full bg-[#1877F2] text-white font-semibold hover:bg-[#1465d1] transition-colors shadow-lg shadow-blue-500/20"
            data-testid="contact-facebook-link"
            aria-label="Follow CertiSeal on Facebook"
          >
            <Facebook className="w-5 h-5" fill="currentColor" />
            <span>Follow us on Facebook</span>
          </a>
        </div>
      </main>
    </div>
  );
}

function ContactCard({ icon: Icon, label, children, testId }) {
  return (
    <Card className="p-7 border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900" data-testid={testId}>
      <div className="flex items-start gap-4">
        <div className="w-11 h-11 rounded-md bg-blue-50 dark:bg-blue-950/40 border border-blue-100 dark:border-blue-900 flex items-center justify-center flex-shrink-0">
          <Icon className="w-5 h-5 text-blue-600 dark:text-blue-400" strokeWidth={2.5} />
        </div>
        <div className="min-w-0 flex-1">
          <div className="text-[11px] uppercase tracking-widest font-semibold text-slate-500 dark:text-slate-400 mb-2">{label}</div>
          {children}
        </div>
      </div>
    </Card>
  );
}
